.spark {
  display: block;
  overflow: visible;
}

.line {
  fill: none;
  stroke: currentColor;
  stroke-width: 1.5;
  stroke-linecap: round;
  stroke-linejoin: round;
  vector-effect: non-scaling-stroke;
}

.area {
  fill: currentColor;
  opacity: 0.14;
  stroke: none;
}

/* Tone is set on the svg so both paths inherit through `currentColor`. */
.spark[data-tone='up'] {
  color: var(--brand-green);
}

.spark[data-tone='down'] {
  color: var(--color-danger);
}

.spark[data-tone='flat'] {
  color: var(--text-muted);
}
